/**
 * Counts the task filters the user has active.
 *
 * @param {object} filters - Filters slice state.
 * @param {object} supplierSelected - Selected supplier ({ id: 'all' } means none).
 * @returns {number} Number of active filters.
 */
export function countActiveFilters(filters, supplierSelected) {
  let n = 0;
  if (filters.completed) n++;
  if (filters.priority) n++;
  if (filters.overhead) n++;
  if (filters.aisle) n++;
  if (filters.spread_to_fill != null) n++;
  if (supplierSelected?.id && supplierSelected.id !== 'all') n++;
  return n;
}

/**
 * Counts only the filters that narrow the task universe. `completed` is
 * excluded: it flips which half of the counts is displayed without
 * shrinking the totals. `spread_to_fill` counts only for stockout, mirroring
 * the guard getTasksProgress applies: a stale key left over from a task-type
 * switch never reaches the request, so it must not count here either.
 *
 * @param {object} filters - Filters slice state.
 * @param {object} supplierSelected - Selected supplier ({ id: 'all' } means none).
 * @param {string} currentTaskType - Active task type.
 * @returns {number} Number of narrowing filters.
 */
export function countNarrowingFilters(filters, supplierSelected, currentTaskType) {
  let n = countActiveFilters(filters, supplierSelected) - (filters.completed ? 1 : 0);
  if (filters.spread_to_fill != null && currentTaskType !== 'stockout') n--;
  return n;
}
